var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChangeUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.73465 8.584L2.12315 10.4355L0.889648 7.481M2.14365 10.304C2.94915 5.589 7.05565 2 12.0001 2C17.5231 2 22.0001 6.477 22.0001 12C22.0001 17.523 17.5231 22 12.0001 22C9.50365 22 7.22165 21.084 5.46915 19.571L5.85015 18.425C6.72515 15.775 9.21015 13.995 12.0001 13.995C13.3951 13.995 14.7101 14.44 15.7901 15.22C16.5701 15.7795 17.2251 16.5115 17.6941 17.374M15.0001 8.75C15.0001 10.5449 13.657 12 12.0001 12C10.3433 12 9.00015 10.5449 9.00015 8.75C9.00015 6.95507 10.3433 5.5 12.0001 5.5C13.657 5.5 15.0001 6.95507 15.0001 8.75Z",
    stroke: "#85909F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeUser);
export default __webpack_public_path__ + "static/media/changeUser.2fc2755dffbf935dfb03acc6ce488bda.svg";
export { ForwardRef as ReactComponent };